export default class LoadingOverlayModel {
  isLoading;
  loadingMessage;

  constructor({ isLoading = false, loadingMessage = '' } = {}) {
    this.isLoading = isLoading;
    this.loadingMessage = loadingMessage;
  }

  setLoading({ isLoading = true, loadingMessage = '' }) {
    return new LoadingOverlayModel({
      isLoading,
      loadingMessage,
    });
  }

  clearLoading() {
    return new LoadingOverlayModel({
      isLoading: false,
      loadingMessage: '',
    });
  }
}
